export const CONTACT_NAME = 'CONTACT_NAME';
export const CONTACT_EMAIL = 'CONTACT_EMAIL';
export const CONTACT_PHONE = 'CONTACT_PHONE';
export const CONTACT_PQRS = 'CONTACT_PQRS';
export const CONTACT_CINEMA_ID = 'CONTACT_CINEMA_ID';
export const CONTACT_DESCRIPTION = 'CONTACT_DESCRIPTION';
export const CONTACT_LOADING = 'CONTACT_LOADING';
export const CONTACT_CLEAR = 'CONTACT_CLEAR';
